import './App.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import React from "react";

import {Route, BrowserRouter, Routes} from "react-router-dom";
import TemplateForm from "./template/Template";
import Home from './home/Home';
import UeberUnsMain from "./ueberuns/UeberUns";
import Philosophie from "./ueberuns/Philosophie";
import Geschichte from "./ueberuns/Geschichte";

import GrundstufeMain from "./bildungsangebote/grundstufe/page/IGSGrundstufe";
import SekundarstufeMain from "./bildungsangebote/sekundarstufe/IGSSekundarstufe";
import OberstufeMain from "./bildungsangebote/oberstufe/Main";
import FachoberschuleMain from "./bildungsangebote/fachoberschule/Fachoberschule";
import BerufsfachschuleMain from "./bildungsangebote/berufsfachschule/Main";
import HoehereberufsfachschuleMain from "./bildungsangebote/hoehereberufsfachschule/Main";
import Foerderverein from "./foerderverein/Foerderverein"
import ScrollToTop from "./ScrollTop";
import Impressum from "./impressum/Impressum";
import Datenschutz from "./datenschutz/Datenschutz";
import Karriere from "./karriere/Karriere";
import AnsprechpartnerMenu from "./ansprechpartner/AnsprechpartnerMenu";
import News from "./news/News";
import Downloads from "./downloads/Downloads";
import Kontakt from "./kontakt/Kontakt";

import Newsbg from "./news/Newsbg";
import NewsList from "./news/NewsList";
import NewsDetail from "./news/NewsDetail";
import FAQ from "./home/faq/FAQ";


import GrünerSchulhof from "./projekte/GrünerSchulhof";
import Streit from "./projekte/Streit";
import Pausenspielraum from "./projekte/Pausenspielraum";


import HomeHero from "./home/HomeHero";
import BildungsangeboteSection from "./home/BildungsangeboteSection";


function App() {
    return (
        <div className="App">
            <BrowserRouter>

                    <ScrollToTop />
                    <Routes>
                        {/* ... */}
                    </Routes>

                <Routes>
                    <Route path="/" element={
                        <TemplateForm>
                            <Home/>
                        </TemplateForm>
                    }/>

                    <Route path="/bildungsangebote/igsgrundstufe" element={
                        <TemplateForm>
                            <GrundstufeMain/>
                        </TemplateForm>
                    } />
                    <Route path="/bildungsangebote/igssekundarstufe" element={
                        <TemplateForm>
                            <SekundarstufeMain/>
                        </TemplateForm>
                    } />
                    <Route path="/bildungsangebote/oberstufe" element={
                        <TemplateForm>
                            <OberstufeMain/>
                        </TemplateForm>
                    } />
                    <Route path="/bildungsangebote/fachoberschule" element={
                        <TemplateForm>
                            <FachoberschuleMain/>
                        </TemplateForm>
                    } />
                    <Route path="/bildungsangebote/berufsfachschule" element={
                        <TemplateForm>
                            <BerufsfachschuleMain/>
                        </TemplateForm>
                    } />
                    <Route path="/bildungsangebote/hoehereberufsfachschule" element={
                        <TemplateForm>
                            <HoehereberufsfachschuleMain/>
                        </TemplateForm>
                    } />


                    <Route path="/uberuns" element={
                        <TemplateForm>
                            <UeberUnsMain/>
                        </TemplateForm>
                    }/>
                    <Route path="/philosophie" element={
                        <TemplateForm>
                            <Philosophie/>
                        </TemplateForm>
                    }/>
                    <Route path="/geschichte" element={
                        <TemplateForm>
                            <Geschichte/>
                        </TemplateForm>
                    }/>
                    <Route path ="/karriere" element={
                        <TemplateForm>
                            <Karriere/>
                        </TemplateForm>
                    }/>


                    <Route path ="/organisation" element={
                        <TemplateForm>
                            <AnsprechpartnerMenu/>
                        </TemplateForm>
                    }/>
                    <Route path="/foerderverein" element={
                        <TemplateForm>
                            <Foerderverein/>
                        </TemplateForm>
                    }/>
                    <Route path ="/downloads" element={
                        <TemplateForm>
                            <Downloads/>
                        </TemplateForm>
                    }/>
                    <Route path ="/kontakt" element={
                        <TemplateForm>
                            <Kontakt/>
                        </TemplateForm>
                    }/>

<Route path="/faq-1" element={
  <TemplateForm>
    <FAQ />
  </TemplateForm>
} />






<Route path="/news/:slug" element={
  <TemplateForm>
    <NewsDetail />
  </TemplateForm>
} />

                    <Route path ="/news" element={
                        <TemplateForm>
                            <Newsbg/>
                        </TemplateForm>
                    }/>


/*

                    <Route path ="/grünerschulhof" element={
                        <TemplateForm>
                            <GrünerSchulhof/>
                        </TemplateForm>
                    }/>
                    <Route path ="/streit" element={
                        <TemplateForm>
                            <Streit/>
                        </TemplateForm>
                    }/>
                    <Route path ="/pausenspielraum" element={
                        <TemplateForm>
                            <Pausenspielraum/>
                        </TemplateForm>
                    }/>
*/




                    <Route path="/impressum" element={
                        <TemplateForm>
                            <Impressum/>
                        </TemplateForm>
                    }/>
                    <Route path="/datenschutz" element={
                        <TemplateForm>
                            <Datenschutz/>
                        </TemplateForm>
                    }/>

 <Route path="/homehero" element={
                        <TemplateForm>
                            <HomeHero/>
                        </TemplateForm>
                    }/>
 <Route path="/BildungsangeboteSection" element={
                        <TemplateForm>
                            <BildungsangeboteSection/>
                        </TemplateForm>
                    }/>





                </Routes>
            </BrowserRouter>



        </div>
    );
}

export default App;
